import styled, { css } from 'styled-components'

import { BREAK_POINT_LG } from '@CSSVars/variables'
import { TEXT_GREY, OUTLINE_COLOR_LIGHT, ESTIMATE_HIGHER, ESTIMATE_LOWER } from '@CSSVars/colors'

export const _Unlocked = styled.div`
  position: relative;
  cursor: pointer;
`

export const _ImageBox = styled.div`
  width: 100%;
  padding-bottom: 65%;
  overflow: hidden !important;
  position: relative;
  /* Need this otherwise image will overflow text */
  backface-visibility: hidden;
  transform: translate3d(0,0,0);
  -webkit-overflow-scrolling: touch;
  border-radius: 10px;

  img{
    width: 100%;
    height: 100%;
    display: block;
  }
`

export const _PreviewContent = styled.div`
  position: relative;
  padding: 10px 0 4px;
  > div {
    line-height: 22px;
  }
`

export const _AskingPrice = styled.div`
  line-height: 22px;
  font-size: 18px;
  font-weight: 600;
`

export const _ClosePrice = styled(_AskingPrice)`
  span {
    color: ${TEXT_GREY};
    margin-left: 8px;
    text-decoration: line-through;
  }
`

export const _ListedDays = styled.div`
  font-size: 12px;
  padding-right: 10px;
  color: ${TEXT_GREY};
  display: ${(props) => (props.show ? 'block' : 'none')};

  @media screen and (max-width: ${BREAK_POINT_LG}) {
    display: block;
  }
`

export const _InfoHolder = styled.div`
  margin: 0;


  span {
    width: 11px;
    height: 10px;
    display: inline-block;
    vertical-align: middle;
    color: ${OUTLINE_COLOR_LIGHT};

    position: relative;

    &:after {
      content: " ";
      position: absolute;
      height: 10px;
      width: 1px;
      right: 5px;
      top: -1px;
      background-color: ${OUTLINE_COLOR_LIGHT};
    }
  }
`


export const _InfoItem = styled.div`
  display: inline-flex;
  align-items: center;
  height: 12px;
  font-weight: 500;
  font-size: 12px;
  span, div {
    font-size: 12px;
    font-weight: 500;

  }
  ${({ arrow }) => (arrow !== 0 ? `
    top: -2px;
    position: relative;
    color: ${arrow > 0 ? ESTIMATE_HIGHER : ESTIMATE_LOWER};
    >div {
      color: ${arrow > 0 ? ESTIMATE_HIGHER : ESTIMATE_LOWER};
    }
    &:before {
      content: "";
      left:
      width: 0;
      height: 0;
      margin-right: 3px;
      border-top: ${arrow > 0 ? '0 solid transparent' : `5px solid ${ESTIMATE_LOWER}`};
      border-bottom: ${arrow < 0 ? '0 solid transparent' : `5px solid ${ESTIMATE_HIGHER}`};
      border-right:  3px solid transparent;
      border-left:  3px solid transparent;
    }
    ` : '')}
`

export const _Size = styled.div`
  display: inline;
  font-size: 12px;
`

export const _ExactSize = styled.div`
  font-weight: 600;
  font-size: 12px;
  display: inline;
`
export const _MaintHolder = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  div {
    line-height: 22px;
    font-size: 12px;
    color: ${TEXT_GREY};
  }

`

const bcTextStyle = css`
  line-height: 22px;
  font-size: 12px;
  color: ${TEXT_GREY};
`
export const _Brokerage = styled.div`
  ${bcTextStyle};
  min-height: 22px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: ${({ showMore }) => (showMore ? '3' : '1')};
  line-clamp: ${({ showMore }) => (showMore ? '3' : '1')};
  -webkit-box-orient: vertical;
`

export const _Mls = styled.div`
  ${bcTextStyle};
  margin-bottom: ${({ noMargin }) => (noMargin ? '0' : '4px')};
`

export const _Address = styled.address`
  font-style: normal;
  line-height: 22px;
`

export const _ListingRemovalMessageContainer = styled.div`
  margin-bottom: 8px;
`

export const _InstantEstimate = styled.div`
  display: flex;
  align-items: center;
  font-weight: 600;
  line-height: 24px;
  
  .estimateAnimation {
    margin-right: 4px;
  }
`
